import axios from "axios";
import { config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Add New application
export const add_application = async (values) => {
    let response = await axios.post(baseURL + "/applications", values);
    return response.data;
}

// List of applications
export const get_all_applications = async () => {
    let response = await axios.get(baseURL + "/applications");
    return response.data;
}
// Delete application
export const delete_application= async (id:number) => {
    let response = await axios.delete(baseURL + "/applications/"+id);
    return response.data;
}
// Edit application
export const update_application = async (id:number,formData:object) => {
    const response = await axios.post(baseURL + "/update-application/" + id, formData, config_multipart)
  return response.data;
}
export const single_application_log = async (id:number) => {
    const response = await axios.get(baseURL + "/single-application-log/" + id)
  return response.data;
}
export const get_all_applications_logs = async () => {
    const response = await axios.get(baseURL + "/all-applications-logs")
  return response.data;
}